let menuOpened = false;

document.getElementById("HeaderMenu-shop").addEventListener("mouseenter", mouseOverMenu);
document.getElementById("HeaderMenu-MenuList-2").addEventListener("mouseenter", mouseOverMenu);
document.getElementById("HeaderMenu-shop").addEventListener("mouseleave", mouseOutMenu);
document.getElementById("HeaderMenu-MenuList-2").addEventListener("mouseleave", mouseOutMenu);
document.getElementById("Details-HeaderMenu-2").addEventListener("click", toggleMenu);

function mouseOverMenu() {
  if (!menuOpened) {
    document.getElementById("HeaderMenu-shop").click();
    menuOpened = true;
  }
}

function mouseOutMenu() {
  if (menuOpened) {
    document.getElementById("HeaderMenu-shop").click();
    menuOpened = false;
  }
}

function toggleMenu() {
  menuOpened = !menuOpened; 
}
